import * as RadixSwitch from "@radix-ui/react-switch";
import { forwardRef } from "react";
import { cn } from "@/lib/cn";

export type SwitchProps = RadixSwitch.SwitchProps & {
  label?: string;
};

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(({ className, label, ...props }, ref) => (
  <label className={cn("bfrs-inline-flex bfrs-items-center bfrs-gap-2 bfrs-text-sm bfrs-text-text-primary", props.disabled && "bfrs-text-text-disabled")}>
    <RadixSwitch.Root
      ref={ref}
      className={cn(
        "bfrs-relative bfrs-h-6 bfrs-w-11 bfrs-rounded-pill bfrs-bg-border-strong bfrs-outline-none bfrs-transition focus-visible:bfrs-ring-2 focus-visible:bfrs-ring-border-focus/25 disabled:bfrs-cursor-not-allowed disabled:bfrs-opacity-50 data-[state=checked]:bfrs-bg-primary",
        className
      )}
      {...props}
    >
      <RadixSwitch.Thumb className="bfrs-block bfrs-size-5 bfrs-translate-x-0.5 bfrs-rounded-pill bfrs-bg-surface-card bfrs-shadow-low bfrs-transition-transform data-[state=checked]:bfrs-translate-x-[22px]" />
    </RadixSwitch.Root>
    {label && <span>{label}</span>}
  </label>
));

Switch.displayName = "Switch";
